import gql from 'graphql-tag';

export default gql`
    query GetCurrentUser {
        me {
            id
            email
            firstName
            lastName
            referralId
            wallets {
                id
                balance
                default
            }
            roles
            countUserReferals
            countUserDonations
            favoriteCause{
                favoriteCauseActivityId
                donateMonthly
            }
            accessToPartners {
                menuItemText
                menuItemAccess
            }
        }
    }
`;
